/* eslint-disable react-hooks/exhaustive-deps */
import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { customGet, customPost } from "../../../utils/services";
import BreadCrumb from "../../../components/common/BreadCrumb";
import CustomTable from "../../../components/common/CustomTable";
import Spinner from "../../../components/common/Spinner";
import ModalLarge from "../../../components/common/ModalLarge";
import ModalMedium from "../../../components/common/Modal_medium";

const tableColumns = [
    { title: "id", value: "id", tipo: "text" },
    { title: "Usuario", value: "usuario.name", tipo: "text" },
    { title: "Observaciones", value: "observaciones", tipo: "text" },
    { title: "Fecha Inicial", value: "fecha_inicial", tipo: "datetime" },
    { title: "Fecha Final", value: "fecha_final", tipo: "datetime" }
];
const {
    REACT_APP_API_URL
} = process.env;

const formatMoneda = (valor) =>
    `Q ${Number(valor || 0).toLocaleString("es-GT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;

export const TableCortesRestaurante = () => {
    const token = useSelector((state) => state.loginReducer.data.token);
    const [urlFetch, setUrlFech] = useState(undefined);
    const [dataTable, setDataTable] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [order, setOrder] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [corteSeleccionado, setCorteSeleccionado] = useState(null);
    const [ordenes, setOrdenes] = useState([]);
    const permiso = "restaurante-ingreso-corte";

    const handleVer = (registro) => {
        setCorteSeleccionado(registro);
        setOrdenes([]);
        setOpenModal(true);
        setModalLoading(true);

        customPost(
            {
                user_id: registro.user_id,
                fecha_inicio: registro.fecha_inicial,
                fecha_fin: registro.fecha_final,
            },
            "cortes/ordenes-corte",
            token
        )
            .then((res) => {
                setOrdenes(res?.data || []);
                setModalLoading(false);
            })
            .catch(() => {
                setOrdenes([]);
                setModalLoading(false);
            });
    };

    const handleImprimir = (registro) => {
        window.open(`${REACT_APP_API_URL}/imprimir-corte/${registro.id}`, "_blank");
    };

    const cerrarModal = () => {
        setOpenModal(false);
        setCorteSeleccionado(null);
        setOrdenes([]);
    };

    useEffect(() => {
        setTableLoading(true);
        customGet(urlFetch, `cortes/listar/restaurante`, token).then((data) => {
            setDataTable(data);
            setTableLoading(false);
        });
    }, [urlFetch]);

    const categoriasPago = [
        { key: "efectivo", label: "Efectivo", match: (n) => n.includes("efectivo") },
        { key: "deposito", label: "Deposito", match: (n) => n.includes("deposito") || n.includes("transfer") || n.includes("trasfer") },
        { key: "tarjeta", label: "Tarjeta", match: (n) => n.includes("tarjeta") },
        { key: "visa_link", label: "Visa Link", match: (n) => n.includes("visa") },
        { key: "credito", label: "Credito", match: (n) => n.includes("credito") },
        { key: "cheque", label: "Cheque", match: (n) => n.includes("cheque") },
    ];

    const resumenPagos = categoriasPago.reduce(
        (acc, cat) => ({ ...acc, [cat.key]: 0 }),
        { otros: 0 }
    );

    ordenes.forEach((pedido) => {
        (pedido.pagos || []).forEach((pago) => {
            const monto = Number(pago.monto || 0);
            const nombre = (pago?.tipo_pago?.nombre || "").toLowerCase();
            const categoria = categoriasPago.find((cat) => cat.match(nombre));
            if (categoria) {
                resumenPagos[categoria.key] += monto;
            } else {
                resumenPagos.otros += monto;
            }
        });
    });

    const totalPagos = Object.values(resumenPagos).reduce((acc, val) => acc + val, 0);

    const pages = [
        { name: "Listado de Cortes - Restaurante", href: "/", current: false },
    ];

    return (
        <div>
            <div className="flex flex-row justify-between items-end sm:flex mx-5 mt-2">
                <BreadCrumb navegacion={pages} />
                <div className="flex flex-row">
                </div>
            </div>
            <div className="shadow border border-gray-300 rounded-lg overflow-x-auto mx-5 mt-2">
                <CustomTable
                    dataTable={dataTable}
                    tableColumns={tableColumns}
                    fetchPage={setUrlFech}
                    pagination={true}
                    showVer={true}
                    handleVer={handleVer}
                    showImprimir={true}
                    handleImprimir={handleImprimir}
                    showEditar={false}
                    showEliminar={false}
                    setOrder={setOrder}
                    order={order}
                    permiso={permiso}
                />
                {tableLoading && (
                    <div className="mt-10 mb-10">
                        <Spinner />
                    </div>
                )}
            </div>

            {openModal && (
                <ModalLarge
                    open={openModal}
                    title={`Detalle del Corte${corteSeleccionado ? ` #${corteSeleccionado.id}` : ""}`}
                    closeModal={cerrarModal}
                    cerrar={cerrarModal}
                >
                    <div className="mt-2 flex flex-col lg:flex-row gap-5 text-sm text-primaryFont">
                        {/* Columna izquierda: encabezado + resumen de pagos */}
                        <div className="lg:w-2/5 lg:flex-shrink-0 space-y-4">
                            {corteSeleccionado && (
                                <div className="rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                                    <div className="bg-gray-50 border-b border-gray-200 px-4 py-2">
                                        <p className="text-xs font-bold uppercase tracking-wide text-gray-500">
                                            Información del corte
                                        </p>
                                    </div>
                                    <div className="px-4 py-3 space-y-2">
                                        <p className="flex justify-between gap-2">
                                            <span className="font-semibold text-gray-500">Usuario</span>
                                            <span className="text-gray-800 text-right">{corteSeleccionado?.usuario?.name}</span>
                                        </p>
                                        <p className="flex justify-between gap-2">
                                            <span className="font-semibold text-gray-500">Fecha Inicial</span>
                                            <span className="text-gray-800 text-right tabular-nums">{moment(corteSeleccionado.fecha_inicial).format("DD-MM-YYYY HH:mm")}</span>
                                        </p>
                                        <p className="flex justify-between gap-2">
                                            <span className="font-semibold text-gray-500">Fecha Final</span>
                                            <span className="text-gray-800 text-right tabular-nums">{moment(corteSeleccionado.fecha_final).format("DD-MM-YYYY HH:mm")}</span>
                                        </p>
                                    </div>
                                </div>
                            )}

                            {!modalLoading && (
                                <div>
                                    <p className="text-xs font-bold uppercase tracking-wide text-gray-500 mb-2">
                                        Resumen de pagos
                                    </p>
                                    <div className="overflow-hidden rounded-lg border border-gray-200 shadow-sm">
                                        <table className="w-full text-sm">
                                            <thead className="bg-primaryFont text-white">
                                                <tr>
                                                    <th className="px-4 py-2 text-left font-semibold">Tipo de pago</th>
                                                    <th className="px-4 py-2 text-right font-semibold">Monto</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-100">
                                                {categoriasPago.map((cat, idx) => (
                                                    <tr key={`resumen-${cat.key}`} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                                                        <td className="px-4 py-2 text-gray-700">{cat.label}</td>
                                                        <td className="px-4 py-2 text-right tabular-nums text-gray-800">{formatMoneda(resumenPagos[cat.key])}</td>
                                                    </tr>
                                                ))}
                                                {resumenPagos.otros > 0 && (
                                                    <tr className="bg-white">
                                                        <td className="px-4 py-2 text-gray-700">Otros</td>
                                                        <td className="px-4 py-2 text-right tabular-nums text-gray-800">{formatMoneda(resumenPagos.otros)}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr className="bg-green-100 text-green-800 font-bold border-t-2 border-green-200">
                                                    <td className="px-4 py-2 uppercase text-xs tracking-wide">Total</td>
                                                    <td className="px-4 py-2 text-right tabular-nums text-base">{formatMoneda(totalPagos)}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Columna derecha: detalle de las órdenes */}
                        <div className="flex-1 lg:border-l lg:border-gray-200 lg:pl-5">
                            {modalLoading ? (
                                <div className="mt-10 mb-10">
                                    <Spinner />
                                </div>
                            ) : (
                                <div className="max-h-[28rem] overflow-y-auto pr-1">
                                    <p className="text-xs font-bold uppercase tracking-wide text-gray-500 mb-2">
                                        Órdenes ({ordenes.length})
                                    </p>
                                    {ordenes.length === 0 ? (
                                        <p className="text-center text-gray-500 py-6">
                                            No se encontraron órdenes para este corte.
                                        </p>
                                    ) : (
                                        ordenes.map((pedido) => {
                                            const totalDetalle = (pedido.detalle || []).reduce(
                                                (acc, item) => acc + Number(item.precio || 0) * Number(item.cantidad || 0),
                                                0
                                            );
                                            return (
                                                <div
                                                    key={`pedido-${pedido.id}`}
                                                    className="rounded-lg border border-gray-200 shadow-sm mb-4 overflow-hidden"
                                                >
                                                    <div className="flex flex-wrap justify-between items-center gap-2 bg-gray-50 border-b border-gray-200 px-4 py-2">
                                                        <span className="font-bold text-gray-700">
                                                            Pedido #{pedido.id}
                                                        </span>
                                                        <div className="flex items-center gap-2">
                                                            {pedido.mesa && (
                                                                <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                                                                    Mesa {pedido.mesa}
                                                                </span>
                                                            )}
                                                            <span className="px-2 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                                                {pedido?.estado?.nombre}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <table className="w-full text-sm">
                                                        <thead className="bg-white border-b border-gray-100">
                                                            <tr className="text-left text-xs uppercase tracking-wide text-gray-400">
                                                                <th className="px-4 py-2 font-semibold">Producto</th>
                                                                <th className="px-4 py-2 font-semibold text-center">Cant.</th>
                                                                <th className="px-4 py-2 font-semibold text-right">Precio</th>
                                                                <th className="px-4 py-2 font-semibold text-right">Subtotal</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="divide-y divide-gray-100">
                                                            {(pedido.detalle || []).map((item, idx) => (
                                                                <tr key={`detalle-${pedido.id}-${idx}`} className="hover:bg-gray-50">
                                                                    <td className="px-4 py-2 text-gray-700">{item?.menu?.nombre}</td>
                                                                    <td className="px-4 py-2 text-center text-gray-700">{item.cantidad}</td>
                                                                    <td className="px-4 py-2 text-right tabular-nums text-gray-600">{formatMoneda(item.precio)}</td>
                                                                    <td className="px-4 py-2 text-right tabular-nums font-medium text-gray-800">
                                                                        {formatMoneda(Number(item.precio || 0) * Number(item.cantidad || 0))}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                    <div className="px-4 py-3 bg-gray-50 border-t border-gray-100">
                                                        {(pedido.pagos || []).length > 0 && (
                                                            <div className="mb-2">
                                                                <p className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-1">Pagos</p>
                                                                <div className="flex flex-wrap gap-2">
                                                                    {(pedido.pagos || []).map((pago, idx) => (
                                                                        <span
                                                                            key={`pago-${pedido.id}-${idx}`}
                                                                            className="inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-full bg-white border border-gray-200 text-gray-700"
                                                                        >
                                                                            <span className="font-medium">{pago?.tipo_pago?.nombre}:</span>
                                                                            <span className="tabular-nums">{formatMoneda(pago.monto)}</span>
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="flex justify-end items-center gap-2 text-sm">
                                                            <span className="text-gray-500">Total:</span>
                                                            <span className="font-bold text-gray-800 tabular-nums">{formatMoneda(totalDetalle)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </ModalLarge>
            )}
        </div>
    );
};
